export default {
  answers: 'Answers',
  goBack: 'Go Back',
  done: 'Done',
  yes: 'Yes',
  no: 'No',
  newMessages: 'New Messages',
};
